

export class AlertOutputWithStatus implements IAlertOutputWithStatus {
    /** The auto-generated id of the alert master */
    alert_id!: number;
    /** The alert name with 255 character limit */
    alert_name!: string;
    /** Manage status of alert type. 0 For De-active, 1 For Active */
    status!: number;

    constructor(data?: IAlertOutputWithStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alert_id = _data["alert_id"];
            this.alert_name = _data["alert_name"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): AlertOutputWithStatus {
        data = typeof data === 'object' ? data : {};
        let result = new AlertOutputWithStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alert_id"] = this.alert_id;
        data["alert_name"] = this.alert_name;
        data["status"] = this.status;
        return data; 
    }
}

export interface IAlertOutputWithStatus {
    /** The auto-generated id of the alert master */
    alert_id: number;
    /** The alert name with 255 character limit */
    alert_name: string;
    /** Manage status of alert type. 0 For De-active, 1 For Active */
    status: number;
}

